export const ML_SCORE_SLIDER = "ml-score";
